import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "./ThemeProvider";

// #347 item 1: a cycle-button hid the theme options (you could only discover
// Light/Dark/System by clicking through them). Segmented control keeps all
// three visible with the active one highlighted — the "make it more
// visible/present" ask, without growing the header footprint.
const OPTIONS = [
  { value: "light", label: "Light", Icon: Sun },
  { value: "dark", label: "Dark", Icon: Moon },
  { value: "system", label: "System", Icon: Monitor },
] as const;

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Colour theme"
      className="flex items-center gap-0.5 rounded-lg border border-border bg-muted/40 p-0.5"
    >
      {OPTIONS.map(({ value, label, Icon }) => {
        const active = theme === value;
        return (
          <button
            key={value}
            role="radio"
            aria-checked={active}
            onClick={() => setTheme(value)}
            title={`${label} theme`}
            className={`flex items-center gap-1.5 rounded-md px-2 py-1.5 text-sm transition-colors ${
              active
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <Icon className="h-4 w-4" />
            <span className={`hidden ${active ? "md:inline" : ""}`}>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
